import { useTranslation } from "react-i18next"
// import { usePostCard } from "../../hooks/useCards"
import { CardStatuses, CardVendors } from "../../utils/cards";
import CardRequestModal from "../../modals/CardRequestModal/CardRequestModal";
import useModalStore from "../../stores/ModalStore";
// import toast from "react-hot-toast";
// import ligocard from "../../assets/logos/ligocard.svg"
// import nemocard from "../../assets/logos/nemocard.svg"
// import raincard from "../../assets/logos/raincard.svg"
// import localConfig from "../../local_config";
import "./NemoCardLanding.css"

interface NemoCardLandingProps {
    status?: CardStatuses
    vendor?: CardVendors
}

const NemoCardLanding = ({ status, vendor }: NemoCardLandingProps) => {

    const { t } = useTranslation("common");

    const { setModalContent } = useModalStore((state) => {
        return {
            setModalContent: state.setModalContent,
        }
    });

    return (
        <>
            {!status && <div className="nemo-card-request-main-cont">
                <div className="nemo-card-request-text">{t("nemo_card_request_info")}</div>
                <div className="nemo-card-request-title">{t("nemo_card_request")} </div>


                <div className="nemo-card-question-box">
                    <div className="nemo-card-question">
                        {t("nemo_card_top")}
                    </div>
                    <div className="nemo-card-question-answer">
                        <ul>
                             <li>{t("nemo_card_mid_list_item_1")}</li>
                            <li>{t("nemo_card_mid_list_item_2")}</li>
                            <li>{t("nemo_card_mid_list_item_3")}</li>
                        </ul>
                        {t("nemo_card_mid_end")}
                    </div>
                </div>

                <div className="nemo-card-request-call-to-action">{t("nemo_card_call_to_action")}</div>

                <div className="nemo-card-request">
                    <button
                        onClick={() => setModalContent(<CardRequestModal />)}
                        className="request-card-submit-button"
                    >
                        {t("request_card")}
                    </button>
                </div>
            </div>
            }
            {
                status === CardStatuses.BLOCKED &&
                <div className="nemo-card-request">
                    <button
                        onClick={() => setModalContent(<CardRequestModal />)}
                        className="request-card-submit-button-large"
                    >
                        {t("request_card")}
                    </button>
                </div>
            }
            {
                status === CardStatuses.ASSIGNED && vendor === CardVendors.LIGO &&
                <div className="nemo-card-delivery">
                    {/* TODO this will put dinamic delivery info, for now it is only pickup */}
                    <div className="nemo-card-delivery-title">{t("card_delivery")}</div>
                    <div className="nemo-card-delivery-info">
                        <div className="nemo-card-delivery-info-item">
                            <div className="nemo-card-delivery-info-item-key">
                                {t("delivery_method")}
                            </div>
                            <div className="nemo-card-delivery-info-item-value">
                                {t("pick_up")}
                            </div>
                        </div>
                        <div className="nemo-card-delivery-info-item">
                            <div className="nemo-card-delivery-info-item-key">
                                {t("delivery_address")}
                            </div>
                            <div className="nemo-card-delivery-info-item-value">
                                {t("nemo_address")}
                            </div>
                        </div>
                    </div>

                </div>
            }
        </>
    )

}

export default NemoCardLanding